module.exports = __webpack_public_path__ + "img/dataIcon.b854c6a4.svg";